import React from "react";
import StoreAction from "../constants/store-action";
import UserEvent from "../constants/user-event";
import { validateEmail, validatePhoneNumber, validateZip, } from "../utils/validation";
import FetchCustomerInfo from "./customer-info-fetch";
import InputCustomerInfo from "./customer-info-input";
import CustomerInformationInputType from "../constants/customer-information-input-type";
const baseFields = ["email", "phone"];
const allManualFields = [
    ...baseFields,
    ...["givenName", "surname", "address", "zip", "city", "zip"],
];
const handleInputChange = (props, e) => {
    props.dispatchStoreAction(StoreAction.UPDATE_NAMED_VALUE, {
        type: "customer",
        name: e.target.name,
        value: e.target.value,
    });
};
const handleBlur = (props, e) => {
    props.dispatchStoreAction(StoreAction.INTERACT_UPDATE_SPECIFIC, {
        type: "customer",
        name: e.target.name,
    });
};
export default (props) => {
    const isAutomatic = props.data.customer.inputType ===
        CustomerInformationInputType.AUTOMATIC;
    const hasEmailError = !validateEmail(props.data.customer.email);
    const hasPhoneError = props.data.interact.customer.phone &&
        !validatePhoneNumber(props.data.customer.phone);
    const hasGivenNameError = !props.data.customer.givenName;
    const hasSurnameError = !props.data.customer.surname;
    const hasAddressError = !props.data.customer.street;
    const hasZipError = !validateZip(props.data.customer.zip);
    const hasCityError = !props.data.customer.city;
    const hasInteractEmail = props.data.interact.customer.email;
    const hasInteractPhone = props.data.interact.customer.phone;
    const hasInteractGivenName = props.data.interact.customer.givenName;
    const hasInteractSurname = props.data.interact.customer.surname;
    const hasInteractAddress = props.data.interact.customer.address;
    const hasInteractZip = props.data.interact.customer.zip;
    const hasInteractCity = props.data.interact.customer.city;
    const allFieldsAreValid = !(hasEmailError ||
        hasPhoneError ||
        (isAutomatic
            ? false
            : hasGivenNameError ||
                hasSurnameError ||
                hasAddressError ||
                hasZipError ||
                hasCityError));
    const allFieldsAreInteracted = hasInteractEmail &&
        hasInteractPhone &&
        (isAutomatic
            ? true
            : hasInteractGivenName &&
                hasInteractSurname &&
                hasInteractAddress &&
                hasInteractZip &&
                hasInteractCity);
    const handleContinueClick = () => {
        if (!allFieldsAreValid) {
            if (allFieldsAreInteracted)
                return;
            props.dispatchStoreAction(StoreAction.INTERACT_SET_ALL_FROM_LIST, {
                type: "customer",
                value: isAutomatic ? baseFields : allManualFields,
            });
            return;
        }
        if (isAutomatic) {
            props.onIncompleteUserEvent(UserEvent.CUSTOMER_DETAILS_AUTOMATIC_CHOSEN);
        }
        else {
            props.onIncompleteUserEvent(UserEvent.CUSTOMER_DETAILS_MANUAL_CHOSEN);
        }
        props.onProceedToNextStep();
    };
    const displayEmailError = hasInteractEmail && hasEmailError;
    const displayPhoneError = hasInteractPhone && hasPhoneError;
    const onHandleInputChange = (e) => handleInputChange(props, e);
    const onHandleBlur = (e) => handleBlur(props, e);
    return (React.createElement("div", { "data-ecom-page": "" },
        React.createElement("section", { className: "page-section" },
            React.createElement("h1", { className: "h6" }, "Kunduppgifter")),
        isAutomatic && React.createElement(FetchCustomerInfo, Object.assign({}, props)),
        !isAutomatic && React.createElement(InputCustomerInfo, Object.assign({}, props)),
        React.createElement("section", { className: "page-section" },
            React.createElement("div", { "data-ecom-form": "" },
                React.createElement("div", { className: `form-group ${displayEmailError ? " has-error" : ""}` },
                    React.createElement("label", { "data-ecom-inputlabel": "", htmlFor: "information-2-input-email" }, "E-post"),
                    React.createElement("div", { "data-ecom-inputtext": "" },
                        React.createElement("input", { type: "text", id: "information-2-input-email", name: "email", placeholder: "E-postadress", value: props.data.customer.email, onChange: onHandleInputChange, onBlur: onHandleBlur })),
                    React.createElement("div", { className: "form-alert" }, "En giltig e-postadress m\u00E5ste anges")),
                React.createElement("div", { className: `form-group ${displayPhoneError ? " has-error" : ""}` },
                    React.createElement("label", { "data-ecom-inputlabel": "", htmlFor: "information-2-input-phone" }, "Telefonnummer"),
                    React.createElement("div", { "data-ecom-inputtext": "" },
                        React.createElement("input", { type: "text", id: "information-2-input-phone", name: "phone", placeholder: "07X-XXXXXXX", value: props.data.customer.phone, onChange: onHandleInputChange, onBlur: onHandleBlur })),
                    React.createElement("div", { className: "form-alert" }, "Ange ditt telefonnummer")))),
        !props.isWaitingForResponse && (React.createElement("section", { className: "page-section page-section-bottom" },
            React.createElement("div", { "data-ecom-buttonnav": "" },
                React.createElement("div", { className: "button-nav-item" },
                    React.createElement("button", { "data-ecom-button": "full-width", onClick: handleContinueClick }, "G\u00E5 vidare"))),
            React.createElement("div", { "data-ecom-content": "", className: "m-t m-b" },
                React.createElement("p", { className: "text-center font-size-small" },
                    "Dina uppgifter lagras och sparas s\u00E4kert.",
                    React.createElement("br", null),
                    " L\u00E4s mer i v\u00E5r",
                    " ",
                    React.createElement("a", { href: "https://www.wayke.se/personuppgiftspolicy-wayke", target: "_blank" }, "personsuppgiftspolicy"),
                    "."))))));
};
